// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2192":"3c67e087b2ea9c1e","6389":"6b27115f04bb939c","8447":"7b55ac96d5af342b"}[chunkId] + ".css";
};